var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-8"},[(_vm.$attrs.slug)?_c('vuetify-ad',{attrs:{"slug":_vm.$attrs.slug,"medium":"entry-ad"}}):_c('carbon-ad')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }